import Assinar from './Assinar';
import Historico from './Historico';

export const EmprestimosUniformeHistorico = Historico;
export const EmprestimosUniformeAssinar = Assinar;
